import { type FC, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocale } from '@/hooks/useLocale';
import { NovaSparkle } from '../common/NovaSparkle';
import { InterviewIcon, JobIcon, TailorCVIcon } from '../icons/SuggestionIcons';

const SUGGESTIONS = [
    { label: 'seeker:chat.suggestions.buildCV', prompt: 'matchJobs', Icon: JobIcon },
    { label: 'seeker:chat.suggestions.tailorCV', prompt: 'tailorCv', Icon: TailorCVIcon },
    { label: 'seeker:chat.suggestions.prepInterview', prompt: 'interview', Icon: InterviewIcon },
];
const TINTS = ['#A379FE', '#79D2FE', '#799FFE'];

/** Static phone home with three direct starter actions. */
export function MobileWebHome({ name, onSend, disabled, companyActions, children }: {
  name: string;
  onSend: (prompt: string) => void;
  disabled: boolean;
  companyActions?: { label: string; prompt: string; Icon: FC<{ size?: number; color?: string }>; tint: string }[];
  children: ReactNode;
}) {
  const { t } = useTranslation(['common', 'seeker']);
  const { isRTL } = useLocale();
  const actions = companyActions ?? SUGGESTIONS.map((item, index) => ({
    label: t(item.label), prompt: t(`common:chat.home.starterPrompts.${item.prompt}`),
    Icon: item.Icon, tint: TINTS[index],
  }));
  return (
    <main className="tabbio-phone-home" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="tabbio-phone-home-greeting">
        <NovaSparkle size={44} />
        <h1>{name ? t('common:chat.home.greetingMove', { name }) : t('common:chat.home.greetingMoveNoName')}</h1>
      </div>
      <div className="tabbio-phone-home-bottom">
        <div className="tabbio-phone-suggestions">
          {actions.map((action, index) => (
            <div className="tabbio-phone-suggestion-row" key={index}>
              <button type="button" onClick={() => onSend(action.prompt)} disabled={disabled}>
                <action.Icon size={18} color={action.tint} />
                <span>{action.label}</span>
              </button>
            </div>
          ))}
        </div>
        {children}
      </div>
    </main>
  );
}
